import { Component } from '@angular/core';

@Component({
    selector: 'private-layout',
    styleUrls: ['./private.layout.scss'],
    templateUrl: './private.layout.html',
    
})
export class PrivateLayout  {

    constructor() { }
}